<template>
    <div>
        <Author :author="author" :article_count="article_count" :post="post"/>
        <!-- <SocialMedia :social_media="social_media" /> -->
    </div>
</template>

<script>
// import SocialMedia from "@/components/SocialMedia";
import Author from "@/components/Author"
    export default {
        components: {
            // SocialMedia,
            Author,
        },
        props: ["author", "social_media", "article_count", "post"]
    }
</script>

<style lang="scss" scoped>

</style>